module.exports = __webpack_public_path__ + "static/media/intro.6f002e50.mp3";